function Test2() {
  return <h1>Test 2</h1>;
}

export default Test2;
